import {Form, Input} from 'antd';
import UploadImage from 'components/Startup/profile/companyImage';
import ReactQuill from 'react-quill';
import styles from './emailNotification.module.scss';

const EmailNotificationFields = ({
  modules,
  formats,
  onChangeImgUrl,
  emailPreviewImage,
  onChangeEmailPreviewImage,
}) => {
  return (
    <div className={styles['container']}>
      <Form.Item
        rules={[{required: true}]}
        style={{width: 730}}
        name="emailHeader"
        label="Email Header">
        <Input placeholder="Input Email Header Text to be displayed" />
      </Form.Item>
      <div className={styles['quill-container']}>
        <h3>Email Body</h3>
        <Form.Item
          name="emailBody"
          rules={[{required: true, message: 'Email body is required'}]}
          valuePropName="value"
          trigger="onChange"
          // Never hand Quill an undefined value. react-quill v1 guards against
          // a Delta being echoed back by comparing `value` to the delta it last
          // emitted — but it never initialises that field, so an undefined
          // value matches an undefined `lastDeltaChangeSet` and it throws
          // "You are passing the `delta` object ... back as `value`", taking the
          // page down. Switching to this tab resets the form, which is exactly
          // when `emailBody` is undefined.
          getValueProps={value => ({value: value || ''})}
          style={{width: 730}}>
          <ReactQuill
            className={styles.quill}
            theme="snow"
            modules={modules}
            formats={formats}
            placeholder="Write Something"
          />
        </Form.Item>
      </div>
      <Form.Item name="emailBanner" style={{width: 730}}>
        <div className={styles['image-section']}>
          <h2>Upload Banner Image (Optional)</h2>
          <UploadImage
            large
            setImgUrl={onChangeImgUrl}
            setPreviewUrl={onChangeEmailPreviewImage}
            previewUrl={emailPreviewImage}
            bucket="notif-banner-images"
          />
        </div>
      </Form.Item>
    </div>
  );
};

export default EmailNotificationFields;
